import * as types from "../types/cancelledOrder.types";
import moment from "moment";

const initialState = {
  initialData: [],
  initialLoading: false,
  initialPagination: [],
  initialFilter: {
    page: 1,
    limit: 10,
    date: [moment(), moment()],
  },
  initialSingle: [],
};
const CancelledOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CANCELLED_ORDER_DATA:
      return { ...state, initialData: action.payload };
    case types.SET_CANCELLED_ORDER_LOADING:
      return { ...state, initialLoading: action.payload };
    case types.SET_CANCELLED_ORDER_PAGINATION:
      return { ...state, initialPagination: action.payload };
    case types.SET_CANCELLED_ORDER_FILTER:
      return { ...state, initialFilter: action.payload };
    case types.SET_CANCELLED_ORDER_SINGLE:
      return { ...state, initialSingle: action.payload };
    case types.RESET_CANCELLED_ORDER_REDUCER:
      return { 
        ...state, 
        initialData: [],
        initialLoading: false,
        initialPagination: [],
        initialFilter: {
          page: 1,
          limit: 10,
        },
        initialSingle: [],
      };
    default:
      return state;
  }
};
export default CancelledOrderReducer;
